var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 1.5a.5.5 0 0 1 .5-.5h3.086a.5.5 0 0 1 .353.146l1.915 1.915A.5.5 0 0 1 8 3.414V8.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5zM2.5 0A1.5 1.5 0 0 0 1 1.5v7A1.5 1.5 0 0 0 2.5 10h5A1.5 1.5 0 0 0 9 8.5V3.414a1.5 1.5 0 0 0-.44-1.06L6.647.439A1.5 1.5 0 0 0 5.586 0zM11 5.5a.5.5 0 0 0-1 0v4A1.5 1.5 0 0 1 8.5 11H5a.5.5 0 0 0 0 1h3.5A2.5 2.5 0 0 0 11 9.5z",
    clipRule: "evenodd"
  })));
});
const SvgFilesStackUsdsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilesStackUsdsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yIDEuNUMyIDEuMjIzODYgMi4yMjM4NiAxIDIuNSAxSDUuNTg1NzlDNS43MTgzOSAxIDUuODQ1NTcgMS4wNTI2OCA1LjkzOTM0IDEuMTQ2NDVMNy44NTM1NSAzLjA2MDY2QzcuOTQ3MzIgMy4xNTQ0MyA4IDMuMjgxNjEgOCAzLjQxNDIxVjguNUM4IDguNzc2MTQgNy43NzYxNCA5IDcuNSA5SDIuNUMyLjIyMzg2IDkgMiA4Ljc3NjE0IDIgOC41VjEuNVpNMi41IDBDMS42NzE1NyAwIDEgMC42NzE1NzMgMSAxLjVWOC41QzEgOS4zMjg0MyAxLjY3MTU3IDEwIDIuNSAxMEg3LjVDOC4zMjg0MyAxMCA5IDkuMzI4NDMgOSA4LjVWMy40MTQyMUM5IDMuMDE2MzkgOC44NDE5NiAyLjYzNDg2IDguNTYwNjYgMi4zNTM1NUw2LjY0NjQ1IDAuNDM5MzRDNi4zNjUxNCAwLjE1ODAzNSA1Ljk4MzYxIDAgNS41ODU3OSAwSDIuNVpNMTEgNS41QzExIDUuMjIzODYgMTAuNzc2MSA1IDEwLjUgNUMxMC4yMjM5IDUgMTAgNS4yMjM4NiAxMCA1LjVWOS41QzEwIDEwLjMyODQgOS4zMjg0MyAxMSA4LjUgMTFINUM0LjcyMzg2IDExIDQuNSAxMS4yMjM5IDQuNSAxMS41QzQuNSAxMS43NzYxIDQuNzIzODYgMTIgNSAxMkg4LjVDOS44ODA3MSAxMiAxMSAxMC44ODA3IDExIDkuNVY1LjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";